import { render } from "./main-article.vue?vue&type=template&id=5b13152d"
import script from "./main-article.vue?vue&type=script&lang=js"
export * from "./main-article.vue?vue&type=script&lang=js"

import "./main-article.vue?vue&type=style&index=0&id=5b13152d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__